import type {CSSProperties} from "aphrodite";

// HACK(nickbreen): Safari 6.1+ specific styling
// https://browserstrangeness.bitbucket.io/css_hacks.html#webkit
// This is mainly used to handle Safari overflow issues.
export const safariOnly = (styles: CSSProperties): CSSProperties => ({
    ["@media screen and (min-color-index:0) " +
    "and(-webkit-min-device-pixel-ratio:0)"]: {
        "@media": styles,
    },

    // @ts-expect-error - TS2322 - Type '{ [x: string]: { "@media": CSSProperties; }; "@media not all and (min-resolution:.001dpcm)": { "@media": CSSProperties; }; }' is not assignable to type 'CSSProperties'.
    ["@media not all and (min-resolution:.001dpcm)"]: {
        "@media": styles,
    },
});
